import { AgxBadgeType, NswContractStage, QldContractStage } from '@urbanx/agx-ui-components';

export const getContractStageBadgeType = (stage?: QldContractStage | NswContractStage) => {
  if (stage === NswContractStage.AwaitingExchange || stage === NswContractStage.Cancelled)
    return AgxBadgeType.Action; //To Do: clean up contract status

  switch (stage) {
    case QldContractStage.Accepted:
    case NswContractStage.Accepted:
      return AgxBadgeType.Success;
    case QldContractStage.Unconditional:
    case NswContractStage.Unconditional:
      return AgxBadgeType.Waiting;
    case QldContractStage.Terminated:
    case NswContractStage.Terminated:
    case NswContractStage.Withdrawn:
      return AgxBadgeType.Action;
    case QldContractStage.Settled:
    case NswContractStage.Settled:
      return AgxBadgeType.Needed;
    case NswContractStage.PendingSolicitorExchange:
    case NswContractStage.PendingAgentExchange:
    case NswContractStage.Signing:
    case NswContractStage.BuyerSigning:
    case NswContractStage.VendorSigning:
      return AgxBadgeType.Action;
    case NswContractStage.ContractRequested:
      return AgxBadgeType.OnGoing;
    default:
      return AgxBadgeType.Primary;
  }
};
